import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import Search from '@/components/Search';
import Title from '@/components/Title';

const Banner = () => {
  const { t } = useTranslation('faq');
  const router = useRouter();
  const [searchPattern, setSearchPattern] = useState('');
  return (
    <div className="flex h-[293px] w-full flex-col items-center justify-center bg-[url('/images/faq/banner-bg.png')] bg-cover bg-center pt-[69px] lg:h-[342px] lg:pt-[90px] xl:h-[400px]">
      <Title theme="colorful" className="mb-6 px-2 lg:mb-5 xl:mb-6">
        <strong>{t('banner-title')}</strong>
      </Title>
      <Search
        value={searchPattern}
        className="w-[335px] lg:w-[640px] xl:w-[800px]"
        onChange={(value) => {
          setSearchPattern(value);
        }}
        onSearch={() => {
          if (searchPattern) {
            router.push(`/faq/${searchPattern}`);
          }
        }}
      />
    </div>
  );
};

export default Banner;
